import { createStore } from 'vuex'

export default createStore({
  state: {
    patientsIdsLst: [],
    xx:12,
  },
  mutations: {
    setPatientsIdList(state, n) {
      state.patientsIdsLst = n;
    },
  },
  actions: {
    getthis() {
      return this.state.xx1122;
    },
  },
  modules: {
  }
})
